export let closePanelFunc;
export let getDataFunc;
export let prepareForPanelClose;

export function initFunctions(funcs) {
    closePanelFunc = funcs.hide;
    getDataFunc = funcs.getData;
    prepareForPanelClose = funcs.prepareForClose;
}

export function insertFields(screen, data) {
    screen.setCollection(data);
    screen.setLoading(false);
}

export function getData(screen) {
    getDataFunc(screen.name);
    screen.setChanged(false);
}

export function saveData(screensStore) {
    closePanel(screensStore);
}

export function closePanel(screensStore, callback?) {
    screensStore.setInitialized(false);
    prepareForPanelClose && prepareForPanelClose();
    setTimeout(() => {
        closePanelFunc && closePanelFunc(screensStore.isReloadNeeded);
        callback && callback();
    }, 1000);
}

export function getLastLevelFields(screen) {
    return screen.collection.lastLevelFields;
}

export function changeScreen(screensStore, screenId) {
    if (screenId !== screensStore.selectedScreenKey) {
        screensStore.setSelectedScreenKey(screenId);
        if (screensStore.selectedScreen.isEmpty) {
            screensStore.selectedScreen.setLoading(true);
            getData && getData(screensStore);
        }
    }
}

export function scrollField(field) {
    field.parentCollection && field.parentCollection.setExpanded(true);
    field.setMoved && field.setMoved(true);
}

export function selectField(field) {
    const {screen} = field;
    // processing click on unselected field
    if (!field.isSelected) {
        screen.setSelected(field);
    }
}

export const screenActions = {
    changeScreen,
    initFunctions,
    insertFields
};
